import { useEffect, useState } from 'react';
import { Login } from './pages/Login';
import { Vault } from './pages/Vault';
import { TrashView } from './pages/Trash';
import { api } from './lib/api';
import { useStore } from './lib/store';
import { uploadManager } from './lib/uploadManager';

export function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);
  const [view, setView] = useState<'vault' | 'trash'>('vault');
  const theme = useStore((s) => s.theme);
  const lang = useStore((s) => s.lang);

  useEffect(() => { document.documentElement.dataset.theme = theme; }, [theme]);

  useEffect(() => {
    api.get('/api/auth/check').then(() => setAuthed(true), () => setAuthed(false));
  }, []);

  useEffect(() => {
    if (authed) { uploadManager.bindNetwork(); uploadManager.recover(); }
  }, [authed]);

  if (authed === null) return <div className="app"><div className="main" style={{ padding: 40 }}>…</div></div>;
  if (!authed) return <Login onLogin={() => setAuthed(true)} />;

  return (
    <>
      {view === 'vault' ? (
        <Vault onLogout={() => setAuthed(false)} onShowTrash={() => setView('trash')} />
      ) : (
        <TrashView lang={lang} onBack={() => setView('vault')} />
      )}
    </>
  );
}
